import { render } from "./Player.vue?vue&type=template&id=caf51276&scoped=true&ts=true"
import script from "./Player.vue?vue&type=script&setup=true&lang=ts"
export * from "./Player.vue?vue&type=script&setup=true&lang=ts"

import "./Player.vue?vue&type=style&index=0&id=caf51276&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf51276"],['__file',"src/views/player/Player.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "caf51276"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('caf51276', __exports__)) {
    console.log('reload')
    api.reload('caf51276', __exports__)
  }
  
  module.hot.accept("./Player.vue?vue&type=template&id=caf51276&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('caf51276', render)
  })

}


export default __exports__